/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CheckmarkLargeBoldIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAo0lEQVR4nO2UUQrCMAyGV++X/PFlCfMwuYW+OK+qBIYInVC3TEEWCLSFfH+apO263f7NCh/7U3isU8nufmCxK4vdwwEdNoNzpoDPwGMf5xn8wrDzK5yg42/gJAoS61u675+WJeCt9fMlNY/MWwJ8aUNbAj1hWuqmid0mQCHoZfW0vMuSoGPmnFc34Q3mfFaEEh9RJULJ8KcIoMP0ceV+v7t9zR7uY9kT9npODwAAAABJRU5ErkJggg==)
 */
export const CheckmarkLargeBoldIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22.06 4.94a1.5 1.5 0 0 1 0 2.12l-12 12a1.5 1.5 0 0 1-2.12 0l-6-6a1.5 1.5 0 0 1 2.12-2.12L9 15.88 19.94 4.94a1.5 1.5 0 0 1 2.12 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
